import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, tap } from "rxjs/operators";
import { RankingEndpointsService } from "src/app/api/services";
import * as fromActions from './roomchampions.actions';
import { of } from "rxjs";
import { RankListResponseWrapper } from "src/app/api/models";

@Injectable()
export class RoomchampionsEffects {

    loadRoomchampions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.loadMany),
            mergeMap(({ room, nameSpace }) =>

                this.api.getRoomChampionList({ roomId: room, nameSpace: nameSpace }).pipe(
                    map((roomchampions: RankListResponseWrapper) => {
                        return fromActions.loadManySuccess({ items: [roomchampions] })
                    }),
                    catchError(error =>
                        of(fromActions.loadManyFail({ error })),
                    ),
                ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private api: RankingEndpointsService,
    ) { }

}